import { gql } from '@apollo/client';

/**
 * 揽收地址标准化（揽收站点 2.0）。
 *
 * 与建站/改址落库调用的是**同一个后端方法**（cooperationWarehouseAddressAnalyze），
 * 所以返回值即最终入库地址，前端直接回填即可，不做任何二次加工。
 *
 * 不要退回用通用的 analyzeAddressSimple —— 那个返回的 normalizedComponents 是「用户输入的标准化版本」，
 * 与建站读的 entityComponents 不是一回事，两者必然对不齐。
 */
export const STANDARDIZE_PICKUP_ADDRESS = gql`
  query StandardizePickupAddress($input: PickupStandardizeAddressInput!) {
    standardizePickupAddress(input: $input) {
      addressLine1
      addressLine1WithoutDock
      dock
      addressLine2
      city
      state
      zipcode
      country
      latitude
      longitude
      addressCoreHash
      addressAnalysisHash
      standardizeStatus
      fallbackReason
    }
  }
`;

export interface PickupStandardizeAddressInput {
  street: string;
  city: string;
  state: string;
  zipcode: string;
  unit?: string;
}

export interface PickupStandardizeAddressDto {
  addressLine1: string | null;
  addressLine1WithoutDock: string | null;
  dock: string | null;
  addressLine2: string | null;
  city: string | null;
  state: string | null;
  zipcode: string | null;
  country: string | null;
  latitude: number | null;
  longitude: number | null;
  addressCoreHash: string | null;
  addressAnalysisHash: string | null;
  /** 1成功 2失败 */
  standardizeStatus: number;
  /** exception / no_match / idlog_empty；成功为 null */
  fallbackReason: string | null;
}

export interface StandardizePickupAddressResponse {
  standardizePickupAddress: PickupStandardizeAddressDto;
}

export interface StandardizePickupAddressVariables {
  input: PickupStandardizeAddressInput;
}
